import { IconButtonProps } from '../types';
import React from 'react';
import useFeatureToggleService from 'feature-toggle';

import styles from './IconButton.module.scss';
import ShadcnIconButtonLayoutWeb from './ShadcnIconButtonLayout.web';

function LegacyIconButtonLayoutWeb(props: IconButtonProps) {
  const classes = [
    styles.button,
    styles[props.type],
    props.className || '',
    props.disabled && styles.disabled,
    props.size === 'big' && styles.big
  ];

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <i
      title={props.title}
      className={classes.join(' ')}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (!props.disabled) {
          props.onClick();
        }

      }}
    >
      &nbsp;
    </i>
  );
}

export default function IconButtonLayoutWeb(props: IconButtonProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnIconButtonLayoutWeb {...props} />;
  } else {
    return <LegacyIconButtonLayoutWeb {...props} />;
  }
}
